import * as $ from "jquery";
import * as ko from "knockout";
import * as _ from "lodash";

import { Application } from "../application";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { ActivePanel } from "../state/activePanel";
import { SidebarItemType } from "../state/sidebarItemType";
import { CostbookRowType } from "../../services/state/costbookRowType";
import section = CostbookRowType.section;
import {Bookmark} from "../state/bookmark";
import { StringUtility } from "../utilities/stringUtility";

export class AddBookmarkCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.AddBookmark;

    canExecute = ko.computed(() => {
        if (this.app.state.activePanel() == ActivePanel.Costbook) {
            let estimate = this.app.state.estimate();
            let costbook = this.app.state.costbook();

            if (!estimate || !costbook)
                return false;
            
            let selectedRow = costbook.selectedRow();
            if (selectedRow == null)
                return false;

            return selectedRow.length > 0;
        }

        return false;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        let dfd = $.Deferred();

        if (!this.canExecute())
            return dfd.reject().promise();

        if (this.app.state.activePanel() != ActivePanel.Costbook)
            return dfd.reject().promise();

        let costbook = this.app.state.costbook();
        let estimate = this.app.state.estimate();

        if (!costbook || !estimate)
            return dfd.reject().promise();

        let items = _.sortBy(costbook.selectedRow(), ['index']);
        let selectedRow = items[0];
        let text: string | undefined;
        let sectionTitle: string | undefined;

        switch (selectedRow.type) {
            case CostbookRowType.section:
                text = selectedRow.attributes.sectionTitle;
                break;

            case CostbookRowType.aggregateCostMLET:
            case CostbookRowType.aggregateCost:
            case CostbookRowType.materialCost:
                sectionTitle = selectedRow.attributes.sectionTitle;
                text = selectedRow.attributes.name;
                break;

            case CostbookRowType.purchaseCost:
            case CostbookRowType.equipmentCost:
                sectionTitle = selectedRow.attributes.sectionTitle;
                text = selectedRow.attributes.equipment;
                break;

            case CostbookRowType.text:
                sectionTitle = selectedRow.attributes.sectionTitle;
                text = StringUtility.removeTags(selectedRow.attributes.text);
                break;

        }

        this.app.apiManager.bookmarks.createBookmark({
            text: (text != undefined ? text : ""),
            sectionTitle: (sectionTitle != undefined ? sectionTitle: ""),
            pageNumber: selectedRow.page,
            rowNumber: selectedRow.index,
            estimateId: estimate.id(),
            costbookId: costbook.id
        }).then((data: Bookmark | undefined) => {
            if(data)
                this.app.state.bookmarks.push(data);
            
            this.app.state.activeSidebarItem(undefined);
            this.app.state.activeSidebarItem(SidebarItemType.Bookmarks);
        });

        return dfd.reject().promise();
    }

    name = "Add bookmark";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/addBookmarkCommand.ts